import React from 'react';
import { Card, Typography, Box } from '@mui/material';

export default function PatientHistory() {
  return (
    <Box my={3}>
      <Card sx={{ p: 4 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Patient History
        </Typography>
        <Typography variant="body1">
          {/* Add patient history form or content here */}
          This is a placeholder for the Patient History component.
        </Typography>
      </Card>
    </Box>
  );
}
